import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { FinancialSectionsSetFilterService } from "./../services/financial-sections-set-filter.service";
import { FinancialSummaryCategoriesSetFilterService } from "./../services/financial-items-set-filter.service";
import { Subscription } from "rxjs";
import { ChartType } from "chart.js";
// import { MultiDataSet, Label, Colors } from "ng2-charts";
import { ThemeService } from "../theme/theme-service.service";

@Component({
    selector: "app-financial-summaries-section-items",
    templateUrl: "./financial-summaries-section-items.component.html",
    styleUrls: ["./financial-summaries-section-items.component.scss"],
    standalone: false
})
export class FinancialSummariesSectionItemsComponent
  implements OnInit, OnDestroy
{
  public subscription: Subscription;
  public subscription2: Subscription;
  //filter: string = "assets";
  public title = "";
  public total = 0;
  public chosenValue: string;
  // private donutColorsDefault = [
  //   {
  //     backgroundColor: [
  //       "#34274D",
  //       "#471A66",
  //       "#5C4A7E",
  //       "#BCB7C8",
  //       "#EFEEF8",
  //       "#FFEED6",
  //       "#EBD4C5",
  //       "#98ABB6",
  //     ],
  //   },
  // ];
  // private donutColorsLifeFile = [
  //   {
  //     backgroundColor: ["#FAB432", "#FAB432"],
  //   },
  // ];
  // private donutColorsPem = [
  //   {
  //     backgroundColor: ["#0093D3", "#FDEBCB"],
  //   },
  // ];
  // private donutColorsPalmers = [
  //   {
  //     backgroundColor: ["#751A3F", "#f2e9ec"],
  //   },
  // ];
  public doughnutChartLabels: any[] = [];
  public doughnutChartLabelColors: any;
  public doughnutChartType: ChartType = "doughnut";
  public _myCategoriesBalance: {}[];
  public myJointOwnershipCalc;
  public myFilter;
  public myCategory;
  public noItems: boolean;
  public imgEmptySection: string;
  public titleEmptySection: string;
  public emptyId: string;
  public filter: string;
  public defaultTheme: boolean;
  public lifeFileTheme: boolean;
  public pemTheme: boolean;
  public palmersTheme: boolean;
  public weightmansTheme: boolean;
  selectedSections: { [key: string]: boolean } = {};

  sectionColors: string[];
  sectionData: { percent: number; color: string }[];
  doughnutColors: string[] = [];
  doughnutChartData: any[];
  //@Input() myCategoriesBalance: {}[];
  @Input() set myCategoriesBalance(value: {}[]) {
    this._myCategoriesBalance = value;
    this.filterList(this.myCategory);
    //
  }
  @Input() set jointOwnershipCalc(value) {
    this.myJointOwnershipCalc = value;
  }
  public mySectionList: {}[] = [];
  public showCanvas = false;

  constructor(
    private financialSectionFilterService: FinancialSectionsSetFilterService,
    private financialNetCategoriesService: FinancialSummaryCategoriesSetFilterService,
    public themeService: ThemeService
  ) {}

  async ngOnInit() {
    this.filterList("assets");
    this.subscription = this.financialNetCategoriesService
      .getMessage()
      .subscribe((filter) => {
        this.myCategory = filter;
        this.filterList(filter);
      });
    switch (this.themeService.theme) {
      case "default":
        this.defaultTheme = true;
        break;
      case "life-file":
        this.lifeFileTheme = true;
        break;
      case "pem":
        this.pemTheme = true;
        break;
      case "palmers":
        this.palmersTheme = true;
        break;
      case "weightmans":
        this.weightmansTheme = true;
        break;
    }
  }

  async filterList(filter) {
    this.showCanvas = false;
    this.mySectionList = [];
    this.total = 0;
    let mySections: {}[] = this._myCategoriesBalance["sections"];
    switch (filter) {
      case "assets":
        mySections
          .filter((item) => item["assetTotal"] > 0)
          .forEach((section) => {
            this.mySectionList.push({
              sectionName: section["sectionName"],
              itemCount: section["assetItems"].length,
              sectionTotal: section["assetTotal"],
            });
          });
        this.total = this._myCategoriesBalance["assetTotal"];
        if (this.total === 0) {
          this.filter = "assets";
          this.titleEmptySection = "asset";
          this.emptyId = "myAssets";
        }
        break;
      case "debts":
        mySections
          .filter((item) => item["debtTotal"] > 0)
          .forEach((section) => {
            this.mySectionList.push({
              sectionName: section["sectionName"],
              itemCount: section["debtItems"].length,
              sectionTotal: section["debtTotal"],
            });
          });
        this.total = this._myCategoriesBalance["debtTotal"];
        if (this.total === 0) {
          this.filter = "debts";
          this.titleEmptySection = "debt";
          this.emptyId = "myDebts";
        }
        break;
      case "income":
        mySections
          .filter((item) => item["incomeTotal"] > 0)
          .forEach((section) => {
            this.mySectionList.push({
              sectionName: section["sectionName"],
              itemCount: section["incomeItems"].length,
              sectionTotal: section["incomeTotal"],
            });
          });
        this.total = this._myCategoriesBalance["incomeTotal"];
        if (this.total === 0) {
          this.filter = "income";
          this.titleEmptySection = "income";
          this.emptyId = "myIncome";
        }
        break;
      case "expenses":
        mySections
          .filter((item) => item["expenseTotal"] > 0)
          .forEach((section) => {
            this.mySectionList.push({
              sectionName: section["sectionName"],
              itemCount: section["expenseItems"].length,
              sectionTotal: section["expenseTotal"],
            });
          });
        this.total = this._myCategoriesBalance["expenseTotal"];
        if (this.total === 0) {
          this.filter = "expenses";
          this.titleEmptySection = "expense";
          this.emptyId = "myExpense";
        }
        break;
    }
    switch (filter) {
      case "assets":
        this.title = "Assets";
        break;
      case "debts":
        this.title = "Debts";
        break;
      case "income":
        this.title = "Annual Income";
        break;
      case "expenses":
        this.title = "Annual Expense";
        break;
    }
    if (this.total > 0) {
      this.mySectionList.sort((a, b) => b["sectionTotal"] - a["sectionTotal"]);
      this.doughnutChartLabels = [];
      this.doughnutChartData = [];
      console.log("mySectionList: ", this.mySectionList);
      this.mySectionList.forEach((section) => {
        console.log("section: ", section);
        this.doughnutChartLabels.push(section["sectionName"] + "(%)");
        let myPercent = Math.round(
          (section["sectionTotal"] * 100) / this.total
        );
        this.doughnutChartData.push({
          myPercent: myPercent,
          sectionName: section["sectionName"],
        });
        return "(" + myPercent + "%)";
      });
      console.log("doughnutChartLabels: ", this.doughnutChartLabels);
      console.log("doughnutChartData: ", this.doughnutChartData);
      this.showCanvas = true;
      this.noItems = false;
    } else if (this.total === 0) {
      this.noItems = true;
    }
  }

  getSliceLabel(index: number): string {
    const labels = [
      "first",
      "second",
      "third",
      "fourth",
      "fifth",
      "sixth",
      "seventh",
      "eighth",
      "ninth",
      "tenth",
      "eleventh",
      "twelfth",
      "thirteenth",
      "fourteenth",
      "fifteenth",
      "sixteenth",
      "seventeenth",
      "eighteenth",
      "nineteenth",
      "twentieth",
    ];
    return labels[index] || "";
  }

  getSliceColor(index: number): string {
    let colors: string[] = [];

    switch (this.themeService.theme) {
      case "default":
        colors = [
          "#34274D",
          "#471A66",
          "#4B0082",
          "#6A5ACD",
          "#483D8B",
          "#8A2BE2",
          "#9932CC",
          "#9400D3",
          "#800080",
          "#8B008B",
          "#9370DB",
          "#BA55D3",
          "#DDA0DD",
          "#D8BFD8",
          "#FF00FF",
          "#DA70D6",
          "#C71585",
          "#8B4513",
          "#A52A2A",
        ];
        break;

      case "life-file":
        colors = [
          "#FAB432",
          "#FAB432",
          "#DAA520",
          "#FFD700",
          "#FFAC33",
          "#E6A23C",
          "#FFC107",
          "#FFD54F",
          "#FF8C00",
          "#FFA07A",
          "#FF6347",
          "#FF4500",
          "#FF7256",
          "#E74C3C",
          "#FF5E3A",
          "#FF5733",
          "#FF6F61",
          "#FF6347",
          "#FF4500",
        ];
        break;

      case "pem":
        colors = [
          "#0093D3",
          "#FDEBCB",
          "#008B8B",
          "#00CED1",
          "#00BFFF",
          "#87CEEB",
          "#1E90FF",
          "#4682B4",
          "#4169E1",
          "#6495ED",
          "#7B68EE",
          "#8A2BE2",
          "#6A5ACD",
          "#483D8B",
          "#7B68EE",
          "#9ACD32",
          "#32CD32",
          "#228B22",
          "#008000",
        ];
        break;

      case "palmers":
        colors = [
          "#751A3F",
          "#f2e9ec",
          "#8B4513",
          "#A52A2A",
          "#B22222",
          "#CD5C5C",
          "#DC143C",
          "#FF0000",
          "#FF4500",
          "#FF6347",
          "#FF7F50",
          "#FA8072",
          "#FF69B4",
          "#FF1493",
          "#C71585",
          "#DA70D6",
          "#9400D3",
          "#8A2BE2",
          "#4B0082",
        ];
        break;
      case "weightmans":
        colors = [
          "#004F59",
          "#2E8B57",
        ];
        break;
    }

    return colors[index] || "";
  }

  getSliceWidth(value: number): number {
    const pixelsPerPercent = 3;
    const minWidth = 10;

    // Calculate the height directly based on the value
    const widthInPixels = value * pixelsPerPercent + minWidth;

    return widthInPixels;
  }

  public chartClicked(e: any): void {
    let index = e["active"][0]["_index"];
    this.filterItemsPerSection(this.mySectionList[index]["sectionName"]);
  }

  async filterItemsPerSection(section) {
    // Reset all other sections to false
    Object.keys(this.selectedSections).forEach((key) => {
      this.selectedSections[key] = false;
    });

    // Set the selected section
    this.selectedSections[section] = true;
    console.log("dounught chart data: ", this.doughnutChartData);
    await this.filterList(this.myCategory);
    await this.financialSectionFilterService.changeMessage(section);
    this.scroll("section-view-box");
    this.chosenValue = section;
  }

  scroll(id) {
    var elmnt = document.getElementById(id);
    if (elmnt) {
      elmnt.scrollIntoView();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
